export default [
  {
    name:"自动获取当天",
    type:"toDay",
    func:"toDay",
    value:"this.setValue(__FLOW_PAGE__.getDateTime());//YYYY-MM-DD"
  },
  {
    name:"自动获取当天时间",
    type:"toDay",
    func:"toDay",
    value:"this.setValue(__FLOW_PAGE__.getDateTime(new Date(),'YYYY-MM-DD HH:mm:ss'));//YYYY-MM-DD HH:mm:ss"
  },
  {
    name:"自动获取用户信息",
    type:"getUserInfo",
    func:"getUserInfo",
    value:`
const that=this;
/**
 * getUserInfo(where={user_id},callback)
 */
__FLOW_PAGE__.getUserInfo({},function (res) {
  if(res.code){
    let data=res.data;
    /**
     * id                     user_id,
     * username              登陆帐号
     * name                  姓名
     * phone_number          个人手机
     * department_id         部门编号（同新视窗）
     * position_id           职位id
     * role_ids              角色id列表
     * gender                性别：1男，2女
     * is_dimission          是否已离职 1已离职 0未离职
     * id_type               证件类型
     * id_number             证件号码
     * status                状态 1在用 0禁用
     * extend_department_ids 管理部门ids
     * subordinates          直接下属（hr_user）ids
     * house_ids             房产Ids
     */

    //以下为编写区域
    that.setValue(data.name)


  }
})
    `
  },
  {
    name:"选择组织人员",
    type:"selectPersonnel",
    func:"selectPersonnel",
    value:`
    const that=this;
    __FLOW_PAGE__.selectPersonnel({
      role_id:null, //角色IDs
      department_id:null, //部门IDs
      user_ids:null,  //已选择用户IDs
      user_len: 1,  //可选择数量，默认为1
    },data=>{
      /**
       * data是数组[{id,name,department_name}]
       * id 用户user_id
       * name 用户名称
       * department_name 部门名称
       */
      if(data&&data.length){
        //选择后填入的参数设置函数
        that.setValue(data[0].name)


      }else {
        //未选择人的
        that.setValue("")


      }
    })
    `
  },
  {
    name:"选择房产",
    type:"SelectProjectHouse",
    func:"SelectProjectHouse",
    value:`
const that=this;
__FLOW_PAGE__.SelectProjectHouse({},function (data) {
  /**
   * tree_obj 房产数据
   * tree_str 选择的房产路径名称
   * id  选择的房产
   */
  //以下为编写区域
  that.setValue(data.tree_str)

});
    `
  },
  {
    name:"选择客户对象",
    type:"ErpRoomUser",
    func:"ErpRoomUser",
    value:`
const that=this;
/**
 * ErpRoomUser(house_name,callback)
 * house_name:房产名称
 */
__FLOW_PAGE__.ErpRoomUser("",function (data) {
  /**
   * id 客户ID
   * name 客户名称
   * credentials_code  身份证
   * community_name 所在项目
   */
  //以下为编写区域
  that.setValue(data.name)

});
    `
  },
  {
    name:"选择减免对象",
    type:"HouseReductionSelect",
    func:"HouseReductionSelect",
    value:`
const that=this;
__FLOW_PAGE__.HouseReductionSelect({},function (data) {
  /**
   * ChargeItemName:
   * IsFrozen:
   * PaidChargeSum:
   * advance_id:
   * allocation_id:
   * area:
   * bei:
   * chaobiaodushu:
   * chaobiaoname:
   * chaobiaoshijian:
   * charge:
   * chargeInitial:
   * chargePay:
   * charge_id:
   * charge_name:
   * company_id:
   * delayDays:
   * delayDiscount:
   * delaySum:
   * discount:
   * discountAfterMoney: 减免后金额
   * discountMoney: 减免金额
   * discountType:
   * discount_text:
   * endDate:
   * explain:
   * generate_date:
   * h_name:
   * h_name_date:
   * h_name_idid:
   * house_id:
   * id:
   * is_close_stat:
   * is_closing:
   * jlu:
   * jurisdiction_id:
   * log_name:
   * number:
   * paid_customer_type:
   * payment:
   * payment_date:
   * pindex_id:
   * remark:
   * share_enter_id:
   * should_charge_date:
   * startDate:
   * state:
   * temporary:
   * type:
   * user_owner_id:
   * weiyi:
   * xsc_Amount:
   * xsc_ChargeID_id:
   * xsc_ChargeItemID_id:
   * xsc_ChargeName:
   * xsc_ChargePrice:
   * xsc_ChargeSum:
   * xsc_CurrentReadDegree:
   * xsc_CustomerChargeDetail_id:
   * xsc_Dynameter:
   * xsc_HouseID:
   * xsc_LastReadDegree:
   * xsc_PaidChargeSum:
   * xsc_Price:
   * xsc_Pull_Date:
   * xsc_Pull_Dates:
   * xsc_UseDegrees:
   * xsc_chargeSource:
   * xsc_id:
   * xsc_isPaid:
   * xsc_precinctID:
   * ybiao:
   * ybiaoleix:
   * ymt:
   * ymt1:
   */
  //以下为编写区域
  //that.setValue(data[0].name)

});
    `
  },
  {
    name:"统计收银日报表",
    type:"HouseReductionSelect",
    func:"HouseReductionSelect",
    value:`
// pid、homeName、time为必填项
const that=this;
let time=new Date();
let date_time=__FLOW_PAGE__.getDateTime(time,'X')
__FLOW_PAGE__.getDailyReport({
  pid:"",   //项目ID
  homeName:"",    //房产路径 如：顺德太平洋鼎旺商业中心项目->写字楼
  payStartDate:date_time,   //统计开始时间
  payEndDate:date_time,   //统计结束时间
  targetController:"OrderDailyList",    //不可改变参数
  targetFunction:"excel",   //不可改变参数
  taskName:"收银日报表",   //不可改变参数
},function (url) {
  window.open(__HTTP__.defaults.baseURL+"/"+url)
  setTimeout(function () {
    window.open("https://view.officeapps.live.com/op/embed.aspx?src="+__HTTP__.defaults.baseURL+"/"+url)
  },2000);
})
    `
  },
]





// WEBPACK FOOTER //
// ./src/components/Admin/Flow/config/FlowFormJsExtend.js